import { KeyValue } from "@/main/models/common";
import { CompanyFilterRequest } from "@/main/models/request";

export enum CompanyBranchTypes {
	GET_COMPANY_BRANCH = "@companyBranch/GET_COMPANY_BRANCH",
	SAVE_COMPANY_BRANCH = "@companyBranch/SAVE_COMPANY_BRANCH",
	RESET_REDUCER_COMPANY_BRANCH = "@companyBranch/RESET_REDUCER_COMPANY_BRANCH",
}

export interface CompanyBranchState {
	readonly companyBranch: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetCompanyBranch {
	type: typeof CompanyBranchTypes.GET_COMPANY_BRANCH;
	payload: {
		request: CompanyFilterRequest;
	};
}

export interface SaveCompanyBranch {
	type: typeof CompanyBranchTypes.SAVE_COMPANY_BRANCH;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerCompanyBranch {
	type: typeof CompanyBranchTypes.RESET_REDUCER_COMPANY_BRANCH;
}

export type CompanyBranchActionTypes = GetCompanyBranch | SaveCompanyBranch | ResetReducerCompanyBranch;
